import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';
import { browserHistory } from 'react-router';
import Loading from '../../../components/Loading';
import HotelDetailWithToggle from '../../../components/HotelDetail/HotelDetailWithToggle';

function goBack() {
  browserHistory.back();
}

class BrowseHotelDetail extends React.Component {
  componentWillMount() {
    if (this.props.needFetch) {
      this.props.requestHotel(this.props.id);
    }
    // if id are different request new hotel detail
    if (this.props.hotel) {
      if (this.props.hotel.id !== this.props.id) {
        this.props.requestHotel(this.props.id);
      }
    }
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.id !== nextProps.id) {
      nextProps.requestHotel(this.props.id);
    }
  }

  render() {
    if (this.props.needFetch || this.props.isFetching) {
      return <Loading />;
    }
    console.log(browserHistory);
    return (
      <div>
        {browserHistory.length && (
          <h4>
            <Button onClick={goBack}>
              <i className="fa fa-arrow-left" aria-hidden="true" /> Back
            </Button>
          </h4>
        )}
        <HotelDetailWithToggle hotel={this.props.hotel} showDetail />
      </div>
    );
  }
}

BrowseHotelDetail.propTypes = {
  id: PropTypes.string.isRequired,
  hotel: PropTypes.object.isRequired,
  isFetching: PropTypes.bool.isRequired,
  needFetch: PropTypes.bool.isRequired,
  hasError: PropTypes.bool.isRequired,
  requestHotel: PropTypes.func.isRequired,
};

export default BrowseHotelDetail;



// WEBPACK FOOTER //
// src/routes/hotels/components/BrowseHotelDetail.js